import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { useTenantSettings } from '@/data/tenantSetting';
import PageLoader from '@/components/common/PageLoader';
import Edit from './components/Edit';

const GeneralView = () => {
  const tenantSettings = useTenantSettings();

  if (tenantSettings.isLoading && !tenantSettings.data) {
    return <PageLoader />;
  }

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/setting">Settings</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>General</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            General Settings
          </CardTitle>
          <CardDescription>Manage general settings.</CardDescription>
        </CardHeader>
        <CardContent>
          <Edit />
        </CardContent>
      </Card>
    </>
  );
};

export default GeneralView;
